import styled from "styled-components";
import { HeaderBalanceDefaultBox } from "./header-balance.default.box";


export const HeaderBalanceSICisBox = styled(HeaderBalanceDefaultBox)`
    color: ${props=> props.theme.colors.brandPrimaryContrast};
    text-transform: uppercase;
    letter-spacing: 0.48px;
    font-size: 12px;
`;